import { render, staticRenderFns } from "./UserGetTell.vue?vue&type=template&id=4bce319f&scoped=true&"
import script from "./UserGetTell.vue?vue&type=script&lang=js&"
export * from "./UserGetTell.vue?vue&type=script&lang=js&"
import style0 from "./UserGetTell.vue?vue&type=style&index=0&id=4bce319f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce319f",
  null
  
)

export default component.exports